const RING_CIRCUMFERENCE = 157;

export function ringDashOffset(pct: number): number {
  const clamped = Math.max(0, Math.min(100, pct));
  return RING_CIRCUMFERENCE * (1 - clamped / 100);
}

export { RING_CIRCUMFERENCE };
